export default __webpack_public_path__ + "static/media/ambachtscreme.bc2d0d22.png";